import { generateServiceId } from "@core/domains/identity";

export const BUS_SERVICE = {
  ID: generateServiceId("bus"),
  LABEL: "bus",
} as const;
